import z from 'zod';

export const optionalString = z
  .string()
  .nullish()
  .transform((val) => val?.trim() || null);
